import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import {
  DeleteAPICall,
  postAPICall,
  putAPICall,
  setToastRef,
  showErrorToast,
  showSuccessToast,
  // showToast,
} from "../Api/Api";
import { IoAddOutline } from "react-icons/io5";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { Panel } from "primereact/panel";
import { Toast } from "primereact/toast";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
export default function FromEmailDataTable(props) {
  const [fromMailDataSource, setFromMailDataSource] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null); // State for a single selected email
  const [searchQuery, setSearchQuery] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [editedItems, setEditedItems] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [refreshConfirmation, setRefreshConfirmation] = useState(true);
  const [from, setFrom] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility
  const [errors, setErrors] = useState({
    from: "",
    password: "",
    days: "", // Error for days input
  });
  const toast = useRef(null);
  useEffect(() => {
    setSelectedEmail(null);
    // setToastRef(toast.current);
    if (props?.accountGroupCodeValue) {
      GetFromMail();
    }
  }, [props?.accountGroupCodeValue]); // Only trigger when accountGroupCodeValue changes

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const GetFromMail = async () => {
    if (props.accountGroupCodeValue) {
      const requestBody = {
        accountGroupCode: parseInt(props.accountGroupCodeValue),
      };

      const response = await postAPICall(
        "api/Configuration/GetFromEmailDetail",
        requestBody
      );
      if (response?.data) {
        setFromMailDataSource(response?.data);
      }
    }
  };

  const filteredmailDataSource = fromMailDataSource?.filter((mail) =>
    mail.EmailAddress.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const onSelectionChange = (e) => {
    if (!isNaN(e.value)) {
      return;
    }
    props?.onClickToMail(e.value, "", setSelectedEmail);
    if (selectedEmail?.EmailAddress === e.value?.EmailAddress) {
      setSelectedEmail(null); // Deselect if clicked again
    } else {
      setSelectedEmail(e.value); // Select the new row
    }
  };
  const handleSave = async () => {
    let isValid = true; // Flag to check overall validity
    let errors = {}; // Object to store error messages

    // Validate email (either from state or editedItems)
    const emailValidation = from ? from : editedItems?.EmailAddress;
    if (!emailValidation || !validateEmail(emailValidation)) {
      errors.from = "Please enter a valid email address.";
      isValid = false;
    }

    // Validate password (either from state or editedItems)
    const passwordValidation = password ? password : editedItems?.Password;
    if (!passwordValidation) {
      errors.password = "Password is required.";
      isValid = false;
    }

    // If validation fails, set errors and stop execution
    if (!isValid) {
      setErrors(errors);
      return;
    }

    // Proceed if validation is successful
    try {
      if (editedItems?.SenderId == null) {
        // New record save logic
        const requestBody = {
          fromMail: emailValidation,
          password: passwordValidation,
          accountGroupCode: parseInt(props?.accountGroupCodeValue),
        };

        // API call for POST request
        const response = await postAPICall(
          "api/Configuration/PostFromMailConfiguration",
          requestBody
        );
        if (response?.status === 200) {
          GetFromMail();
          setErrors({}); // Clear errors
          setShowDialog(false); // Close the dialog
          // showToast("success", "From Email added successfully!");
          showSuccessToast("From Email added successfully!");
        } else {
          showErrorToast("error", "Failed to add From Email!");
        }
      } else {
        // Update logic if SenderId exists
        const requestBody = {
          fromMail: emailValidation,
          password: passwordValidation,
          senderId: editedItems?.SenderId,
          accountGroupCode: editedItems?.AccountGroupCode,
        };

        // API call for PUT request
        const response = await putAPICall(
          "api/Configuration/PutFromMailConfiguration",
          requestBody
        );
        if (response?.status === 200) {
          // showToast("success", "Successfully updated!");
          showSuccessToast("Successfully updated!");
          setEditedItems(null); // Clear the edited items
          GetFromMail(); // Refresh the data
          setErrors({}); // Clear errors
          setShowDialog(false); // Close the dialog
        } else {
          showErrorToast("error", "Update failed!");
        }
      }
    } catch (error) {
      // Handle any API errors
      showErrorToast("error", "An error occurred while saving.");
      setErrors({
        apiError: error?.message || "An unexpected error occurred.",
      });
    }
  };

  const AddNewMailFooter = (
    <div>
      <Button
        id="BtnSave"
        label="Save"
        icon="pi pi-check"
        onClick={handleSave}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setShowDialog(false)}
        className="p-button-text"
      />
    </div>
  );
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleInputFromEmail = (e) => {
    const { value } = e.target;
    setFrom(value); // Update the `from` state
    setEditedItems((prevState) => ({
      ...prevState,
      EmailAddress: value, // Update the `EmailAddress` field in `editedItems`
    }));
  };

  const handleInputPassword = (e) => {
    const { value } = e.target;
    setPassword(value); // Update the `password` state
    setEditedItems((prevState) => ({
      ...prevState,
      Password: value, // Update the `Password` field in `editedItems`
    }));
  };

  const AddMailContent = (
    <>
      <Panel
        header="Mail Configuration"
        style={{ width: "400px", margin: "auto" }}
      >
        <div className="p-fluid">
          {/* From Field */}
          <div className="p-field">
            <label htmlFor="from">Sender Mail</label>
            <InputText
              id="from"
              value={editedItems?.EmailAddress || ""} // Ensure it's controlled properly
              onChange={handleInputFromEmail}
              placeholder="Enter your email address"
              className="p-inputtext p-component"
            />
            {errors.from && <small className="p-error">{errors.from}</small>}
          </div>
          {/* Password Field */}
          <div className="p-field">
            <label htmlFor="password">Sender Mail Password</label>
            <div
              className="password-input-wrapper"
              style={{ position: "relative" }}
            >
              <InputText
                type={showPassword ? "text" : "password"} // Toggle between text and password
                id="password"
                value={editedItems?.Password || ""} // Ensure it's controlled properly
                onChange={handleInputPassword}
                placeholder="Enter your email password"
                className="p-inputtext p-component"
              />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.password && (
              <small className="p-error">{errors.password}</small>
            )}
          </div>
        </div>
      </Panel>
    </>
  );
  const handlePopupOpen = () => {
    setErrors({});
    if (props?.accountGroupCodeValue != null) {
      // setFrom(null);
      setEditedItems(null);
      setShowDialog(true);
    } else {
      showErrorToast("Please Select channel Name !!");
    }
  };
  const handleConfirmDelete = async () => {
    if (editedItems.SenderId) {
      const requestBody = {
        senderId: editedItems.SenderId,
      };
      const response = await DeleteAPICall(
        "api/Configuration/DeleteFromMailConfiguration",
        requestBody
      );
      GetFromMail();
      setRefreshConfirmation(false);
      setDeleteConfirmation(false);
      props?.onClickToMail(selectedEmail, refreshConfirmation);
      setEditedItems(null);
      showSuccessToast("Deleted Successfully..");
    }
  };

  const DeleteConfirmation = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Yes"
          icon="pi pi-check"
          onClick={handleConfirmDelete}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="No"
          icon="pi pi-times"
          onClick={() => setDeleteConfirmation(false)}
          className="p-button-text"
        />
      </div>
    </>
  );
  const actionTemplate = (rowData) => {
    const handleActionClick = (e) => {
      e.stopPropagation();
    };

    const handleEdit = (rowData) => {
      setShowDialog(true);
      setEditedItems({ ...rowData });
    };
    const handleDelete = (rowdata) => {
      setEditedItems({ ...rowdata });
      setDeleteConfirmation(true);
    };
    return (
      <div onClick={handleActionClick}>
        <Button
          id="UserTOAccountEditIcon"
          icon={<MdModeEdit />}
          title="Edit"
          className="p-button-rounded p-button-primary p-mr-2"
          onClick={() => handleEdit(rowData)}
        />
        <Button
          id="UserTOAccountDeleteIcon"
          icon={<MdDelete />}
          title="Delete"
          className="p-button-rounded p-button-primary"
          onClick={() => {
            handleDelete(rowData);
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />
      <div
        id="plus_search"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <b
          style={{
            color: "lightslategray",
            marginRight: "auto",
            marginTop: "10px",
          }}
        >
          {props?.accountGroupName}
        </b>
        <Button
          icon={
            <IoAddOutline
              style={{ color: "darkslategrey", fontSize: "50px" }}
            />
          }
          id="MasterPlusicon"
          onClick={handlePopupOpen}
          className="p-button p-button-icon"
          title="Add"
        />
        <InputText
          id="AccountGroupSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>

      <DataTable
        className="FromDataTable"
        header="From Email"
        scrollable
        scrollHeight="440px"
        value={filteredmailDataSource}
        selection={selectedEmail} // Bind a single selected row
        onSelectionChange={onSelectionChange} // Handle selection change
        // Use a unique key for selection
      >
        <Column selectionMode="single" style={{ width: "3em" }} />
        {/* Single selection */}
        <Column field="EmailAddress" header="Sender Email" sortable />
        <Column header="Actions" body={actionTemplate} />
      </DataTable>
      <GlobalPopup
        title="Sender Mail"
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        footerButtons={AddNewMailFooter}
        content={AddMailContent}
      />
      <GlobalPopup
        title={"Confirmation"}
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={DeleteConfirmation}
        content={
          <div className="confirmation-content">
            Are you sure you want to delete this item?
          </div>
        }
      />
    </div>
  );
}
